<template>
    <div class="page white_bg">

        <header class="pageHeader paddingH16 paddingV8 white_bg" style="line-height: 30px;">
            <div class="borderLayout">
                <div class="middleRegion">
                    <div class="westRegion" style="width: 60px">
                        <router-link to="/" class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;"></router-link>
                    </div>
                    <div class="centerRegion alignCenter font18r primaryTextColor bold"
                         style="height: 30px; overflow: hidden">
                        {{title}}
                    </div>
                    <div class="eastRegion font14r alignRight" style="width: 60px">
                    </div>
                </div>
            </div>
        </header>

        <div class="body" style="padding-bottom: 34px;">

            <article class="article" v-html="dataItem ? dataItem : ''"></article>

            <!--                <div class="imageArea">-->
            <!--                    <img class="alignC bgC1C1C1 block" src="" style="min-height: 544px; line-height: 80px;"-->
            <!--                         alt="介绍图片"/>-->
            <!--                </div>-->

            <div class="marginT20 paddingH20">
                <router-link :to="{name:'kindergartenAuthForm'}" class="requestButton block alignC font14r">
                    申请成为园长
                </router-link>
            </div>

        </div><!-- end .body -->

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

const config = {
    name : 'kindergartenAuth',
    title : '园所认证',
    description : '',
    apiConfig : {
        get : {
            url : 'portal/about/get_Agreement',
            params : {
                code : 'auth_info_kindergarten'
            }
        }
    }
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {  },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,

            enableDataItem : true,
            autoLoadDataItem : true
        }
    },
    methods : {
    }
}
</script>

<style lang="scss" scoped>
.requestButton {
    display: block;
    width: 100%;
    padding: 0;
    background: #FFB946;
    color: white;
    border-radius: 4px;
    height: 40px;
    line-height: 40px;
    border: none;
}
</style>
